import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { books } from "../books/BookData";
import plan1 from "../../assets/img/plan1.PNG";
import plan2 from "../../assets/img/plan2.PNG";
import plan3 from "../../assets/img/plan3.PNG";

const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : process.env.REACT_APP_API_URL;

const readingPlans = [
  { title: "PLAN DE LECTURA 1", image: plan1 },
  { title: "PLAN DE LECTURA 2", image: plan2 },
  { title: "PLAN DE LECTURA 3", image: plan3 },
];

const Features = () => {
  const [verse, setVerse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [featuredBook, setFeaturedBook] = useState(null);
  const [dailyPlan, setDailyPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/api/verse-of-the-day/`)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((data) => {
        setVerse(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching verse of the day:", err);
        setError("No se pudo cargar el versículo.");
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("featuredBook");
    const today = new Date().toDateString();

    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed.date === today && books[parsed.index]) {
          setFeaturedBook(books[parsed.index]);
          return;
        }
      } catch (e) {
        console.error("Error parsing localStorage data:", e);
      }
    }

    const newIndex = Math.floor(Math.random() * books.length);
    const newPick = books[newIndex];
    setFeaturedBook(newPick);
    localStorage.setItem(
      "featuredBook",
      JSON.stringify({ date: today, index: newIndex })
    );
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("dailyPlan");
    const today = new Date().toDateString();

    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.date === today && readingPlans[parsed.index]) {
        setDailyPlan(readingPlans[parsed.index]);
        return;
      }
    }

    const newIndex = Math.floor(Math.random() * readingPlans.length);
    setDailyPlan(readingPlans[newIndex]);
    localStorage.setItem(
      "dailyPlan",
      JSON.stringify({ date: today, index: newIndex })
    );
  }, []);

  return (
    <div className="w-full max-w-7xl mx-auto py-10 sm:py-20 font-bembo text-lg px-4 sm:px-0">
      <div className="grid sm:grid-cols-3 gap-12 sm:gap-10 px-2 sm:px-0 items-stretch">
        {/* Book Recommendation */}
        <div className="flex flex-col justify-between items-center text-center max-w-xs mx-auto w-full h-full">
          <h2 className="text-xl sm:text-2xl font-bold mb-4">
            RECOMENDACIONES DE LIBROS
          </h2>
          {featuredBook && (
            <>
              <button
                type="button"
                onClick={() => navigate("/libros")}
                className="cursor-pointer transition-transform hover:scale-105"
                title="Ir a Libros"
                aria-label={`Ir a la página de Libros: ${featuredBook.title}`}
              >
                <img
                  src={featuredBook.image}
                  alt={`Portada de ${featuredBook.title}`}
                  className="w-44 h-44 sm:w-52 sm:h-52 object-cover rounded-xl shadow-lg mb-4"
                />
              </button>
              <p className="font-semibold text-xl sm:text-2xl">
                {featuredBook.title}
              </p>
            </>
          )}
        </div>

        {/* Verse of the Day */}
        <div className="flex flex-col justify-between items-center text-center max-w-xs mx-auto w-full h-full">
          <h2 className="text-xl sm:text-2xl font-bold mb-4">
            VERSICULO DIARIO
          </h2>
          <button
            type="button"
            onClick={() => navigate("/buscador")}
            title="Ir al Buscador"
            aria-label="Ir al Buscador de versículos"
            className="bg-white border border-gray-200 rounded-xl shadow-lg p-4 w-64 h-64 sm:w-72 sm:h-72 overflow-hidden cursor-pointer hover:scale-105 transition-transform"
          >
            {loading && (
              <p className="text-gray-500 text-center mt-20">
                Cargando versículo...
              </p>
            )}
            {error && <p className="text-red-600 text-center mt-20">{error}</p>}
            {verse && (
              <div className="flex flex-col justify-center h-full">
                <p className="text-lg text-gray-600 mb-2">
                  <span className="font-bold">
                    {verse.book} {verse.chapter}:{verse.verse}
                  </span>
                </p>
                <p className="text-md leading-relaxed text-justify text-gray-800">
                  {verse.text}
                </p>
              </div>
            )}
          </button>
        </div>

        {/* Reading Plan Preview */}
        {dailyPlan && (
          <div className="flex flex-col justify-between items-center text-center max-w-xs mx-auto w-full h-full">
            <h2 className="text-xl sm:text-2xl font-bold mb-4">
              PLANES DE LECTURA
            </h2>
            <button
              type="button"
              onClick={() => navigate("/planlectura")}
              className="cursor-pointer transition-transform hover:scale-105"
              title="Ir a Planes"
              aria-label={`Ir a la página de Planes de Lectura: ${dailyPlan.title}`}
            >
              <img
                src={dailyPlan.image}
                alt={`Vista previa de ${dailyPlan.title}`}
                className="w-44 h-44 sm:w-52 sm:h-52 object-cover rounded-xl shadow-lg mb-4"
              />
            </button>
            <p className="font-semibold text-xl sm:text-2xl">
              {dailyPlan.title}
            </p>
          </div>
        )}
      </div>
      <br />
      <br />
    </div>
  );
};

export default Features;
